import { createFileRoute } from '@tanstack/react-router'
import CreateProjectModalGate from '../../../../../containers/project-menu/components/create-project-modal-gate'
import { createProjectSearchSchema } from '../search-schemas'

export const Route = createFileRoute('/_authenticated/project/_projects/new/')({
  validateSearch: createProjectSearchSchema,
  component: CreateProjectModalGate
})
